module.exports = __webpack_public_path__ + "static/media/stop-20.4de640c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-20.svg
// module id = 1387
// module chunks = 0